/* eslint-disable */
<template>

  <div class="container has-text-centered" style="height: 91vh;">

    <div class="column is-4 is-offset-4">
      <h3 class="title has-text-grey">Login</h3>
      <p class="subtitle has-text-grey">INCUBE PORTAL</p>
      <div class="box">
        <figure class="avatar">
            <img :src="require('@/assets/favicon.png')" style="width: 50%;">
        </figure>
        <form>
          <div class="field">
            <div class="control">
              <input 
                v-model="form.username"
                class="input is-large"
                type="email"
                placeholder="Username"
                autocomplete="email">
              <!-- <div class="form-error">
                <span class="help is-danger">Email is required</span>
                <span class="help is-danger">Email address is not valid</span>
              </div> -->
            </div>
          </div>
      
          <div class="field">
            <div class="control">
              <input 
                v-model="form.password"
                class="input is-large"
                type="password"
                placeholder="Password"
                autocomplete="current-password">
              <!-- <div class="form-error">
                <span class="help is-danger">Password is required</span>
              </div> -->
            </div>
          </div>
 
          <button 
            @click="handleLogin"
            type="button"
            class="button is-block is-info is-large is-fullwidth"
            style="margin-bottom: 10px;">Sign In</button>
        
         
    <v-snackbar
      v-model="form.snackbar"
    >
     {{form.snakMsg}}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="form.snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>


        </form>
      </div>

    </div>
  </div>
  
</template>

<script>

import AppHeader from '@/components/Header'
import { db,fb  } from '@/db'
import { mapMutations, mapState } from 'vuex'

export default {
  data() {
    return {
      form: {
       snackbar: false,
       username: '',
       password: '',
       snakMsg : 'error',
      }
    }
  },
  methods: {
      ...mapMutations({
        setUser: 'Set_User',
        setusertype : 'Set_UserType',
      }),
    handleLogin() {
    debugger
    var data1 = db
      .collection('Users')
      .where('UserName' , '==' , this.form.username)
      .get()
      .then(snapshots => {
        debugger
        if(snapshots.docs.length > 0) {
            const user =snapshots.docs[0];
            if (user.data().Password == this.form.password){
              var type = user.data().Type
              this.setUser(this.form.username )
              this.setusertype(type)

              this.$router.push('/')
           
             
            }else{
              this.form.snakMsg = 'Wrong Password !!'
              this.form.snackbar = true;
               
            }
        }else{
              this.form.snakMsg = 'User Not Found !!'
              this.form.snackbar = true;
             
        }
      })
    
    return
    }
  }
}
</script>

<style scoped>
  .hero.is-success {
    background: #F2F6FA;
  }
  .hero .nav, .hero.is-success .nav {
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .box {
    margin-top: 5rem;
  }
  .avatar {
    margin-top: -70px;
    padding-bottom: 20px;
  }
  .avatar img {
    padding: 5px;
    background: #fff;
    border-radius: 50%;
    -webkit-box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
    box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
  }
  input {
    font-weight: 300;
  }
  p {
    font-weight: 700;
  }
  p.subtitle {
    padding-top: 1rem;
  }
</style>